import { NgModule } from '@angular/core';
import { BackButtonDirective } from './back-button/back-button.directive';

@NgModule({
  imports: [],
  declarations: [
    BackButtonDirective,
  ],
  exports: [
    BackButtonDirective,
  ],
})
export class DirectivesModules {}
